import { render, staticRenderFns } from "./programByObjective.vue?vue&type=template&id=6ff69702&scoped=true"
import script from "./programByObjective.vue?vue&type=script&lang=js"
export * from "./programByObjective.vue?vue&type=script&lang=js"
import style0 from "./programByObjective.vue?vue&type=style&index=0&id=6ff69702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff69702",
  null
  
)

export default component.exports